(function (angular, schoolwork12) {
    'use strict';
    
    //TODO: encapsulate localstorage data in future for better performannce
    angular.module(schoolwork12.app.common.name)
    .factory('storage', 
            ['$window', 
                function($window) {
                   var getData = function(key) {
                            var data = $window.localStorage.getItem('X-API-TOKEN');
                            return angular.fromJson(data);
                        },
                       setData = function(key, value) {
                            $window.localStorage.setItem('X-API-TOKEN',angular.toJson(value));  
                       };
                    return {
                        getData: getData,
                        setData: setData
                    };
                    
                }
            ]);
}(angular, schoolwork12));